module.exports = __webpack_public_path__ + "img/user-icon.615a20fe.svg";